import { useState, useEffect, useCallback } from 'react';
import { fetchJobs } from '../services/jobsAPI';
import { Job } from '../types';

export const useJobs = () => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const performFetch = useCallback(async () => {
    setError(null);
    try {
      const fetchedJobs = await fetchJobs();
      setJobs(fetchedJobs);
    } catch (err) {
      setError('Failed to fetch jobs. Please check your connection and try again.');
      console.error(err);
    }
  }, []);

  useEffect(() => {
    const initialLoad = async () => {
      setIsLoading(true);
      await performFetch();
      setIsLoading(false);
    };
    initialLoad();
  }, [performFetch]);

  const refetchJobs = useCallback(async () => {
    setIsRefreshing(true);
    await performFetch();
    setIsRefreshing(false);
  }, [performFetch]);


  return { jobs, isLoading, isRefreshing, error, refetchJobs };
};
